import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';

import { PageTitle } from 'components/pages/pageTitle';
import { callApi } from 'helpers/callApi/callApi';
import { MoEventDetailsTable } from './table/MoEventDetailsTable';
import { MoEventDetailsProps, MoEventDetailsState } from './MoEventDetails.types';

export class MoEventDetails extends Component<MoEventDetailsProps, MoEventDetailsState> {
  constructor(props: MoEventDetailsProps) {
    super(props);

    this.state = {
      data: undefined,
      error: false,
    };
  }

  componentDidMount(): void {
    const { fetch } = this.props;

    callApi({
      action: fetch,
      onSuccess: ({ payload }) => {
        this.setState({ data: payload });
      },
      onFailure: () => {
        this.setState({ error: true, data: [] });
      },
    });
  }

  render() {
    const { data, error } = this.state;

    return (
      <>
        <PageTitle displayTitle="Marching Orders Event Details" />
        {error && <div>Something went wrong</div>}
        {!!data || <BeatLoader />}
        {!!data && <MoEventDetailsTable data={data} />}
      </>
    );
  }
}
